import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { POLTERSORRY } from '../interface/interface';

@Pipe({
    name: 'contractName',
    standalone: false
})
export class ContractNamePipe implements PipeTransform {

  transform(address: string, ...args: unknown[]): any {
    let chainId = args[0] as string
    switch (address) {
      case environment[chainId]['FACTORY_ADDRESS']:
        return "FACTORY CONTRACT"
      case environment[chainId]['ACCESS_CONTROL_TOKEN']:
        return "ACCESS CONTRACT"
      case environment[chainId]['NFT_LOAN_CONTRACT_TEST']:
        return "LOAN PLATFORM FEE CONTRACT TESTNET"
      case environment[chainId]['NFT_LOAN_CONTRACT_DEV']:
        return "LOAN PLATFORM FEE CONTRACT"
      case environment[chainId]['BORROW_LEND_CONTRACT']:
        return "BORROW LEND CONTRACT"
      case environment[chainId]['EXCHANGE_CONTRACT']:
        return "EXCHANGE CONTRACT"
      case environment.POL_TREASURY_WALLET:
        return POLTERSORRY
      default:
        return address !== POLTERSORRY ? address.slice(0, 7) + '...' + address.slice(address.length - 7) : address
    }
  }

}
